import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of} from 'rxjs';
import { Prenotazione } from '../models/prenotazione.model';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PrenotazioneService {
  private apiUrl = environment.apiBaseUrl + '/prenotazioni'; // Replace with your API URL

  constructor(private http: HttpClient) { }

  getPrenotazioni(day: string, prestazione: string | null): Observable<{message: string, prenotazioni: any}> {
    // Timestamp anticache
    const timestamp = new Date().getTime();

    //Ritorno tutte le prenotazioni
    return this.http.get<{message: string, prenotazioni: any}>(`${this.apiUrl}/${prestazione}/${day}?timestamp=${timestamp}`);
  }

  getAllPrenotazioni(prestazione: string | null): Observable<{message: string, endCache: string, prenotazioni: any}> {
    // Timestamp anticache
    const timestamp = new Date().getTime();

    //Ritorno tutte le prenotazioni
    return this.http.get<{message: string, endCache: string, prenotazioni: any}>(`${this.apiUrl}/get-all-prenotazioni/${prestazione}?timestamp=${timestamp}`);
  }

  getPrenotazione(id: string): Observable<Prenotazione> {
    return this.http.get<Prenotazione>(`${this.apiUrl}/${id}`);
  }

createPrenotazione(prenotazione: any): Observable<Prenotazione> {
  return this.http.post<Prenotazione>(this.apiUrl, prenotazione)
    .pipe(
      catchError(this.handleError('createPrenotazione', prenotazione))
    );
}

private handleError<T>(operation = 'operation', result?: T) {
  return (error: any): Observable<T> => {
    console.error(`${operation} failed: ${error.message}`);
    return of(result as T);
  };
}

  updatePrenotazione(id: string | undefined, prenotazione: Prenotazione): Observable<Prenotazione> {
    return this.http.put<Prenotazione>(`${this.apiUrl}/${id}`, prenotazione);
  }

  deletePrenotazione(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  updateTimer(id: string, newTimer: string): Observable<any> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.post(url, { timer: newTimer });
  }
}
